import moment from 'moment';

export const formatDiffSince = date => {
  if (!date || !moment.isMoment(date)) {
    return '';
  }
  return moment(date).fromNow();
};
